module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.hasTopBorder && 'top-border'],
    style: _vm.newTabBarStyle
  }, [(_vm.mutilTabGroups.length > 0) ? _c('div', [_vm._t("default", [_c('div', {
    staticClass: ["mutil-tab-bar-container"],
    style: _vm.mutilTabBarContainerStyle
  }, _vm._l((_vm.mutilTabGroups), function(item, index) {
    return _c('div', {
      key: index,
      class: ['mutil-tab-bar-item', item.disabled && 'tab-bar-item-disabled']
    }, [(!item.launchText) ? _c('div', {
      staticClass: ["mutil-icon-wrapper"]
    }, [(item.hasDot === true) ? _c('div', {
      staticClass: ["dot-triangle"],
      style: {
        backgroundColor: item.iconColor
      }
    }) : _vm._e(), _c('div', {
      staticClass: ["icon-container"]
    }, [_c('div', {
      ref: ("animate-circle-" + index),
      refInFor: true,
      staticClass: ["animate-circle"]
    }), _c('div', {
      ref: ("animate-circle-bg-" + index),
      refInFor: true,
      staticClass: ["icon-inner-container"],
      style: {
        backgroundColor: item.iconColor
      },
      on: {
        "click": function($event) {
          _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        },
        "touchstart": function($event) {
          _vm.shrinkCircleFn(item, index, _vm.tabGroups)
        },
        "touchend": function($event) {
          _vm.expandCircleFn(item, index, _vm.tabGroups)
        }
      }
    }, [(item.loading) ? _c('dof-spinner', {
      staticClass: ["tab-bar-item-loading"],
      attrs: {
        "type": _vm.resolveLoadingIcon(item.iconColor)
      }
    }) : (item.icon) ? _c('image', {
      staticClass: ["tab-bar-item-icon"],
      attrs: {
        "src": item.icon
      }
    }) : (item.iconfont) ? _c('dof-iconfont', {
      attrs: {
        "code": item.iconfont,
        "size": item.iconfontSize || 96,
        "color": item.iconfontColor || 'rgba(255,255,255, 0.4)'
      }
    }) : (item.iconText) ? _c('text', {
      staticClass: ["tab-bar-item-icon-text"],
      style: {
        color: !!item.iconTextColor ? item.iconTextColor : _vm._iconTextColor
      }
    }, [_vm._v(_vm._s(item.iconText))]) : _vm._e()], 1)])]) : _vm._e(), (item.launchText) ? _c('div', {
      staticClass: ["is-launch"],
      style: {
        backgroundColor: item.launchBg,
        width: item.launchWidth
      }
    }, [_c('text', {
      staticClass: ["is-launch-text"],
      style: {
        color: item.launchColor
      }
    }, [_vm._v(_vm._s(item.launchText))])]) : _vm._e()])
  }))])], 2) : _c('div', {
    staticClass: ["tab-bar-container"]
  }, [_c('div', {
    staticClass: ["tab-bar-list"]
  }, [_vm._t("default", _vm._l((_vm.tabGroups), function(item, index) {
    return _c('div', {
      key: index,
      class: ['tab-bar-item', item.disabled && 'tab-bar-item-disabled']
    }, [_c('div', {
      staticClass: ["icon-wrapper"]
    }, [(item.hasDot === true) ? _c('div', {
      staticClass: ["dot-triangle"],
      style: {
        backgroundColor: item.borderColor ? item.borderColor : item.iconColor ? item.iconColor : _vm._iconColor
      }
    }) : _vm._e(), _c('div', {
      staticClass: ["icon-container"],
      style: {
        width: _vm.widthCalcBig(item)
      }
    }, [_c('div', {
      ref: ("animate-circle-" + index),
      refInFor: true,
      staticClass: ["animate-circle"],
      style: {
        width: _vm.widthCalcSmall(item)
      }
    }), _c('div', {
      ref: ("animate-circle-bg-" + index),
      refInFor: true,
      staticClass: ["icon-inner-container"],
      style: {
        width: _vm.widthCalc(item),
        backgroundColor: _vm.handleBg(item),
        borderWidth: '2px',
        borderColor: item.borderColor ? item.borderColor : item.iconColor ? item.iconColor : _vm._iconColor
      },
      on: {
        "click": function($event) {
          _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        },
        "touchstart": function($event) {
          _vm.shrinkCircleFn(item, index, _vm.tabGroups)
        },
        "touchend": function($event) {
          _vm.expandCircleFn(item, index, _vm.tabGroups)
        }
      }
    }, [(item.loading) ? _c('dof-spinner', {
      staticClass: ["tab-bar-item-loading"],
      attrs: {
        "type": _vm.resolveLoadingIcon(item.iconColor)
      }
    }) : (item.icon) ? _c('image', {
      staticClass: ["tab-bar-item-icon"],
      attrs: {
        "src": item.icon
      }
    }) : (item.iconfont) ? _c('dof-iconfont', {
      attrs: {
        "code": item.iconfont,
        "size": item.iconfontSize || 96,
        "color": item.iconfontColor || 'rgb(102,102,102)'
      }
    }) : (item.iconText) ? _c('text', {
      staticClass: ["tab-bar-item-icon-text"],
      style: {
        color: item.textColor ? item.textColor : _vm.handleIconTextColor(item)
      }
    }, [_vm._v(_vm._s(item.iconText))]) : _vm._e()], 1), (_vm._isColmo && !item.disabled && !item.loading) ? _c('div', {
      staticClass: ["mask"],
      style: {
        width: _vm.widthCalc(item)
      },
      on: {
        "click": function($event) {
          _vm.tabBarItemClicked(item, index, _vm.tabGroups)
        }
      }
    }) : _vm._e()])]), _c('div', {
      staticClass: ["tab-bar-item-title"]
    }, [_c('text', {
      staticClass: ["tab-bar-item-title-text"]
    }, [_vm._v(_vm._s(item.text))])])])
  }))], 2)]), (_vm.isIPhoneX) ? _c('div', {
    staticClass: ["line-wrapper"]
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-2379436c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-bottom-bar/index.vue
// module id = 582
// module chunks = 0 1